import { useContext } from "react"
import { EditorToolbarColorDropdown, EditorToolbarTray } from "./EditorToolbarUI";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorColorsTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarColorDropdown
                icon={<MaterialIcon name='format_size' weight={300}/>}
                defaultValue={'#000000'}
                selectedValue={editorState.currentColor}
                onChange={(value) => {
                    if(value) editor.chain().focus().setColor(value).run();
                    else editor.chain().focus().unsetColor().run();
                }}
            />
            <EditorToolbarColorDropdown
                icon={<MaterialIcon name='ink_highlighter' weight={300}/>}
                defaultValue={'#FFFFFF00'}
                selectedValue={editorState.currentHighlight}
                onChange={(value) => {
                    if(value) editor.chain().focus().setHighlight({color: value}).run();
                    else editor.chain().focus().unsetHighlight().run();
                }}
                highlight
            />
        </EditorToolbarTray>
    )
}





                    